import { Session } from 'src_common/sdk/session';
import { AppEnvParamsBrowser } from 'src/utils/appEnvParams';
import { SdkCustomerConfig } from 'src/AppState/sdk/staff';
import { apiGetSettingsRequest, ApiGetSettingsResponseType } from 'src/api_openapi/v2/settingsService/apiGetSettings';
import {
    apiListSettingsRequest,
    ApiListSettingsResponseType,
} from 'src/api_openapi/v2/settingsService/apiListSettings';
import {
    apiPatchServiceRequest,
    ApiPatchServiceResponseType,
} from 'src/api_openapi/v2/settingsService/apiPatchService';

export class SdkSettingsService {
    public constructor(
        private readonly session: Session,
        public readonly config: SdkCustomerConfig,
        private readonly envParamsBrowser: AppEnvParamsBrowser
    ) {}

    public async getAllServices(): Promise<ApiListSettingsResponseType> {
        return apiListSettingsRequest(
            `${this.envParamsBrowser.gatewayUrl}`,
            {},
            {
                authorization: `Bearer ${this.session.currentJwt}`,
            }
        );
    }

    public async getServiceSettings(serviceId: string): Promise<ApiGetSettingsResponseType> {
        return apiGetSettingsRequest(
            `${this.envParamsBrowser.gatewayUrl}`,
            {
                serviceId,
            },
            {
                authorization: `Bearer ${this.session.currentJwt}`,
            }
        );
    }

    public async patchServiceSettings(serviceId: string, data: unknown): Promise<ApiPatchServiceResponseType> {
        return apiPatchServiceRequest(
            `${this.envParamsBrowser.gatewayUrl}`,
            {
                serviceId,
                requestBody: {
                    data,
                },
            },
            {
                authorization: `Bearer ${this.session.currentJwt}`,
            }
        );
    }
}
